export default "__VITE_ASSET__DcTeC3Fs__"